<mat-card class="admin-card">

  <div class="admin-header">

    <div class="results-badge">
      Results: {{ dataSource.data.length }}
    </div>

    <div class="admin-header-actions">
      <button 
        mat-icon-button 
        class="icon-btn-grey"
        (click)="getUsers()" 
        matTooltip="Refresh users"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

  </div>

  <div class="admin-table-wrap">

    <table mat-table [dataSource]="dataSource" matSort class="admin-table">

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="actions-row">

            <button
              mat-icon-button
              (click)="openUserDetails(element)"
              matTooltip="Open user details"
            >
              <mat-icon>info_outline</mat-icon>
            </button>

          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let user">
          {{ getUserName(user) | titlecase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let user">
          {{ user.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
        <td mat-cell *matCellDef="let user">
          @if (user.role === 'admin') {
            <span class="tag blue">
              Admin
            </span>
          } @else {
            <span class="tag grey">
              User
            </span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
        <td mat-cell *matCellDef="let user">
          {{ user.created_at | date:'MM/dd/yyyy' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updated_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
        <td mat-cell *matCellDef="let user">
          {{ user.updated_at | date:'MM/dd/yyyy' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="last_login_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</th>
        <td mat-cell *matCellDef="let user">
          {{ user.last_login_at | date:'MM/dd/yyyy' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="last_active_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Active</th>
        <td mat-cell *matCellDef="let user">
          {{ user.last_active_at | date:'MM/dd/yyyy' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="admin-row"></tr>

    </table>

    <mat-paginator
      class="admin-paginator"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
    >
    </mat-paginator>

  </div>

</mat-card>